import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Glow').create(({ theme }) => ({
  root: {
    backgroundColor: theme.colors.borders.epic,
    content: '""',
    position: 'absolute',
    zIndex: '0',
    width: '100%',
    // height: '30px',
    aspectRatio: '1/1',
    bottom: '0%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '9999px',
    filter: 'blur(130px)',
  },
}))
